export const API_AUTH = "https://script.google.com/macros/s/AKfycbwyb3swoTE9OEiKgMbLe5Ox6TW38LxI58hd3VUIwBRoHIwhBAs6ca8QtDLR0avJxoL-/exec";
export const API_DATA = API_AUTH; // Will point to data script once deployed

export const C = {
  blue: "#4A90D9", blueMid: "#5B9FE4", blueLight: "#E8F0FE",
  navy: "#1A2744", navyLight: "#243356",
  red: "#C41E2A",
  grayBg: "#F6F8FB", border: "#E2E5EA", white: "#FFF",
  t1: "#1E293B", t2: "#5A6577", t3: "#94A3B8",
  ok: "#10B981", warn: "#F59E0B", info: "#3B82F6", purple: "#8B5CF6",
};

export const BRANDS = ["AVA Prevent", "Chemori", "Potter", "VES", "Stat-X"];
export const BRAND_QUOTES = { "AVA Prevent": 62500, Chemori: 38200, Potter: 45750, VES: 22000, "Stat-X": 19000 };
export const BRAND_ORDERS = { "AVA Prevent": 41200, Chemori: 28100, Potter: 32500, VES: 12500, "Stat-X": 10000 };
